import { createSelectorFunctions } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

interface Palette {
  isLoading?: boolean;
  error?: Error;
  hex?: string;
  vibrant?: string;
}

export interface AppState {
  guideItemPathname: string;
  hasAdBlocker: boolean;
  guideItemPalettes: Record<string, Palette>;
}

export interface AppActions {
  setGuideItemPathname: (guideId: string) => void;
  setHasAdBlocker: (hasAdBlocker: boolean) => void;
  setGuideItemPalette: (guideId: string, palette: Palette) => void;
}

export type AppStore = AppState & AppActions;
export type InitialAppState = Partial<AppState>;

const defaultState: AppState = {
  guideItemPathname: '',
  hasAdBlocker: false,
  guideItemPalettes: {},
};

export function createAppStore(initialState: InitialAppState = {}) {
  const appStore = create<AppStore>((set) => ({
    ...defaultState,
    ...initialState,

    setGuideItemPathname: (guideItemPathname: string) => set({ guideItemPathname }),
    setHasAdBlocker: (hasAdBlocker: boolean) => set({ hasAdBlocker }),

    setGuideItemPalette: (guideId, palette) =>
      set((state) => ({
        guideItemPalettes: {
          ...state.guideItemPalettes,
          [guideId]: palette,
        },
      })),
  }));

  return createSelectorFunctions(appStore);
}
